import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box } from "@vk-hr-tek/ui/Box";
import { Link } from "@vk-hr-tek/ui/Link";
import { Typography } from "@vk-hr-tek/ui/Typography";
import { WysiwygContent } from "@vk-hr-tek/ui/WysiwygContent";
import { ColoredChip } from "@vk-hr-tek/ui/ColoredChip";
import { Icon } from "@vk-hr-tek/ui/Icon";
import { Divider } from "@vk-hr-tek/ui/Divider";
import { Tooltip } from "@vk-hr-tek/ui/Tooltip";
import { useMeasureOverflow } from "@vk-hr-tek/ui/hooks";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function SurveyAnalyticsQuestion_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else SurveyAnalyticsQuestion_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const parseEditorState = (data)=>{
    try {
        return JSON.parse(data);
    } catch (unused) {
        return {};
    }
};
const questionDataByType = (answerType)=>{
    switch(answerType){
        case 'emoji':
            return {
                icon: 'happy_face_outline',
                tooltipText: 'Оценка смайлами'
            };
        case 'free_text':
            return {
                icon: 'article_outline',
                tooltipText: 'Текст'
            };
        case 'multiple_choice':
            return {
                icon: 'check_square_outline',
                tooltipText: 'Несколько из списка'
            };
        case 'scale':
            return {
                icon: 'vkhrtek_slider_outline',
                tooltipText: 'Шкала'
            };
        case 'single_choice':
            return {
                icon: 'check_circle_outline',
                tooltipText: 'Один из списка'
            };
        case 'stars':
            return {
                icon: 'favorite_outline',
                tooltipText: 'Оценка звездами'
            };
    }
};
const MAX_CONTENT_HEIGHT = 352;
const SurveyAnalyticsQuestion = ({ questionSettings, content, answerType, totalAnswers, getAttachmentUrl, description, flat = false, children })=>{
    var _questionRef_current;
    const { measureRef: questionRef, isOverflowing: isQuestionOverflowing } = useMeasureOverflow();
    const [isQuestionExpanded, setIsQuestionExpanded] = useState(false);
    const { icon, tooltipText } = questionDataByType(answerType);
    return /*#__PURE__*/ jsxs(Box, {
        bgcolor: flat ? 'bg.greyscale.primary' : 'bg.light.primary',
        display: "flex",
        flexDirection: "column",
        gap: "16",
        radius: "l",
        border: flat ? '0' : '1px solid',
        borderColor: "stroke.primary",
        children: [
            /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                flexDirection: "column",
                gap: "8",
                px: flat ? '24' : '0',
                children: [
                    /*#__PURE__*/ jsxs(Box, _object_spread_props(_object_spread({
                        ref: questionRef,
                        maxHeight: isQuestionOverflowing && isQuestionExpanded ? null == (_questionRef_current = questionRef.current) ? void 0 : _questionRef_current.scrollHeight : MAX_CONTENT_HEIGHT,
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8",
                        p: flat ? '0' : '16',
                        pb: "0"
                    }, isQuestionOverflowing && isQuestionExpanded && {
                        maskImage: 'none',
                        WebkitMaskImage: 'none'
                    }, isQuestionOverflowing && !isQuestionExpanded && {
                        maskImage: 'linear-gradient(to bottom, black calc(100% - 32px), transparent calc(100% - 8px))',
                        WebkitMaskImage: 'linear-gradient(to bottom, black calc(100% - 32px), transparent calc(100% - 8px))'
                    }), {
                        transition: "max-height 0.5s",
                        children: [
                            /*#__PURE__*/ jsxs(Box, {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ jsxs(Box, {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12",
                                        children: [
                                            questionSettings.required && /*#__PURE__*/ jsx(ColoredChip, {
                                                size: "extraSmall",
                                                color: "blue",
                                                label: "Обязательный вопрос"
                                            }),
                                            questionSettings.skipped && /*#__PURE__*/ jsx(ColoredChip, {
                                                size: "extraSmall",
                                                color: "orange",
                                                label: "Пропущен",
                                                isBgWhite: flat
                                            }),
                                            /*#__PURE__*/ jsx(ColoredChip, {
                                                size: "extraSmall",
                                                color: "gray",
                                                isBgWhite: flat,
                                                label: "Ответов",
                                                counter: totalAnswers
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ jsx(Tooltip, {
                                        placement: "top",
                                        title: tooltipText,
                                        children: /*#__PURE__*/ jsx(Box, {
                                            children: /*#__PURE__*/ jsx(Icon, {
                                                name: icon,
                                                color: "stroke.secondary",
                                                size: "20"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ jsx(WysiwygContent, {
                                editorStateJSON: parseEditorState((null == content ? void 0 : content.data) || '{}'),
                                getAttachmentUrl: getAttachmentUrl
                            }),
                            description && /*#__PURE__*/ jsx(Typography, {
                                variant: "body3",
                                color: "text.light.secondary",
                                children: description
                            })
                        ]
                    })),
                    isQuestionOverflowing && /*#__PURE__*/ jsx(Box, {
                        pl: "16",
                        children: /*#__PURE__*/ jsx(Link, {
                            stroke: false,
                            onClick: ()=>setIsQuestionExpanded((prev)=>!prev),
                            variant: "tertiary",
                            children: isQuestionExpanded ? 'Скрыть' : 'Показать еще'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ jsx(Divider, {}),
            /*#__PURE__*/ jsx(Box, {
                overflow: "hidden",
                px: flat ? '24' : '16',
                pb: flat ? '0' : '16',
                pt: "0",
                children: children || /*#__PURE__*/ jsx(Box, {
                    radius: "m",
                    bgcolor: "bg.greyscale.secondary",
                    px: "12",
                    py: "8",
                    children: /*#__PURE__*/ jsx(Typography, {
                        variant: "body3",
                        color: "text.light.tertirary",
                        children: "Без ответа"
                    })
                })
            })
        ]
    });
};
export { SurveyAnalyticsQuestion };
